import e from "./ghl-ui.es1195.js";
import m from "./ghl-ui.es1196.js";
import n from "./ghl-ui.es1197.js";
function h(a) {
  var t = m(a);
  return t.length == 1 && t[0][2] ? n(t[0][0], t[0][1]) : function(r) {
    return r === a || e(r, a, t);
  };
}
export {
  h as default
};
